module.exports = __webpack_public_path__ + "img/product_2.2c296e2.webp";